<template>
  <div class="localdata-single-container" :class="{simple}">
    <i v-if="simple" class="text-icon icon-yzm" @click="dialogVisible = true"></i>
    <div v-else :class="`show-label input input-${size}`">
      <span v-if="selected">{{selected && list[selected][1]}}</span>
      <i class="text-icon icon-yzm" @click="dialogVisible = true"></i>
    </div>
    <ee-dialog :title="title" v-model="dialogVisible" size="small">
      <table class="local-data-table">
        <colgroup>
          <col width="200px">
        </colgroup>
        <tbody>
        <tr v-for="c in category">
          <th>{{list[c][1]}}</th>
          <td>
            <span class="local-data-item" :class="{active: selected === list[k][0] }" v-for="k in relations[c]">
              <template v-if="relations[k]">
                {{list[k][1]}}<i v-if="count(k)">{{count(k)}}</i>
                <div class="sub-list">
                  <label class="local-data-item" :class="{active: selected === list[subK][0]}" v-for="subK in relations[k]">
                    <input type="radio" v-model="selected" :value="list[subK][0]">{{list[subK][1]}}
                  </label>
                </div>
              </template>
              <template v-else>
                <label><input type="radio" v-model="selected" :value="list[k][0]">{{list[k][1]}}</label>
              </template>
            </span>
          </td>
        </tr>
        </tbody>
      </table>
      <p class="btn-bar">
        <button type="button" class="btn btn-primary" @click="handleConfirm">确定</button>
        <button type="button" class="btn" @click="handleCancel">取消</button>
      </p>
    </ee-dialog>
  </div>
</template>
<script>
  export default {
    compName: 'ee-localdata-single',
    props: {
      size: {
        type: String,
        default: 'default'
      },
      simple: {
        type: Boolean,
        default: false
      },
      value: [String, Number],
      title: {
        type: String
      },
      initialValue: {
        type: String,
        default: ''
      },
      resource: {
        type: Object,
        required: true
      }
    },
    methods: {
      handleConfirm () {
        this.cache = this.selected
        this.dialogVisible = false
      },
      handleCancel () {
        this.selected = this.cache
        this.dialogVisible = false
      },
      count (k) {
        if (this.relations[k].includes(this.selected)) {
          return 1
        }
      }
    },
    data () {
      // relations list category
      return {
        cache: this.value,
        selected: this.value,
        dialogVisible: false,
        ...this.resource
      }
    },
    watch: {
      selected () {
        this.$emit('input', this.selected)
        this.$emit('change', this.selected)
      },
      value () {
        this.cache = this.value
        this.selected = this.value
      }
    }
  }
</script>
<style>
  .localdata-single-container {
    &.simple {
      display: inline;
      padding: 5px;
      vertical-align: sub;
      .el-icon-more {
        cursor: pointer;
      }
    }
    .show-label {
      position: relative;
      background-color: #fff;
      &.input-large {
        padding: 10px;
        i.text-icon {
          top: 14px;
        }
      }
      &.input-middle {
        padding: 8px 5px;
        i.text-icon {
          top: 12px;
        }
      }
      &.input-default {
        padding: 6px 5px;
      }
      &.input-small {
        padding: 3px 5px;
        i.text-icon {
          top: 7px;
        }
      }
      &.input-tiny {
        padding: 1px 5px;
        i.text-icon {
          top: 5px;
        }
      }
      span {
        float: left;
        padding: 4px;
        margin-right: 5px;
        margin-bottom: 5px;
        background-color: #28a7e1;
        border-radius: 4px;
        line-height: 1;
        color: #fff;
      }
      i {
        right: 6px;
        top: 11px;
        color: #28a7e1;
        position: absolute;
      }
    }
    .ee-dialog__header {
      padding: 5px 20px;
      border-top: 2px solid #34c1ea;
      background-color: #28a7e1;
      .ee-dialog__title {
        color: #fff;
        font-size: 18px;
      }
      .ee-icon {
        &:hover {
           color: #fff;
        }
      }
    }
    .local-data-table {
      th {
        text-align: center;
        vertical-align: middle;
        background-color: #fbfbfb;
      }
      td {
        padding: 25px;
      }
      th, td {
        border: 1px solid #ddd;
      }
    }
    .local-data-item {
      position: relative;
      float: left;
      padding: 3px 5px;
      margin-left: 5px;
      margin-bottom: 5px;
      font-size: 14px;
      line-height: 1;
      cursor: pointer;
      color: #28a7e1;
      input[type="radio"] {
        display: none;
      }
      label {
        cursor: pointer;
      }
      i {
        padding: 0 3px;
        background-color: #28a7e1;
        color: #fff;
        font-style: normal;
      }
      &:hover, &.active {
        color: #fff;
        background-color: #28a7e1;
      }
      &:hover {
        .sub-list {
          display: block;
        }
      }
      .sub-list {
        position: absolute;
        width: 500px;
        top: 100%;
        left: -100%;
        border: 1px solid #28a7e1;
        padding: 10px;
        background-color: #fbfbfb;
        z-index: 10;
        display: none;
      }
    }
    .btn-bar {
      padding: 10px;
      text-align: right;
      .error-msg {
        float: left;
        color: #f00;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/packages/localdata/LocalDataSingle.vue?2354eca5